// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"342":"7adaa30f","421":"4e464acc","632":"f92023a7","766":"1c924b64","896":"612484e2"}[chunkId] + ".chunk.css";
};